// Position templates = named bundles of platform positions; provision entire template to tenant.

import api from './api';

export interface PositionTemplate {
  id: string;
  template_code: string;
  template_name: string;
  description?: string | null;
  is_active: boolean;
  position_count?: number;
  positions?: Array<{ id: string; position_code: string; position_name: string }>;
}

export const positionTemplateService = {
  async list(): Promise<PositionTemplate[]> {
    const response = await api.get('/position-templates');
    return response.data.templates || [];
  },

  async getById(id: string): Promise<PositionTemplate> {
    const response = await api.get(`/position-templates/${id}`);
    return response.data.template;
  },

  async create(data: { template_code: string; template_name: string; description?: string | null; is_active?: boolean }): Promise<PositionTemplate> {
    const response = await api.post('/position-templates', data);
    return response.data.template;
  },

  async update(id: string, data: { template_name?: string; description?: string | null; is_active?: boolean }): Promise<PositionTemplate> {
    const response = await api.put(`/position-templates/${id}`, data);
    return response.data.template;
  },

  async delete(id: string): Promise<void> {
    await api.delete(`/position-templates/${id}`);
  },

  async addPosition(templateId: string, positionId: string): Promise<void> {
    await api.post(`/position-templates/${templateId}/positions`, { positionId });
  },

  async addPositionsBulk(templateId: string, positionIds: string[]): Promise<void> {
    await api.post(`/position-templates/${templateId}/positions/bulk`, { positionIds });
  },

  async removePosition(templateId: string, positionId: string): Promise<void> {
    await api.delete(`/position-templates/${templateId}/positions/${positionId}`);
  },

  async provisionToTenant(tenantId: string, templateId: string): Promise<unknown[]> {
    const response = await api.post('/position-templates/provision-to-tenant', { tenantId, templateId });
    return response.data.provisioned || [];
  },

  async copyTemplate(sourceId: string, data: { template_code: string; template_name: string; description?: string | null }): Promise<PositionTemplate> {
    const response = await api.post(`/position-templates/${sourceId}/copy`, data);
    return response.data.template;
  }
};
